var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _path, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDottedBox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 101,
    viewBox: "0 0 137 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.81445,
    y: 5.00031,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2972,
    y: 5.00012,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.81445,
    y: 15.183,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2972,
    y: 15.1835,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.81445,
    y: 25.3677,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2972,
    y: 25.3672,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 4.81445,
    y: 35.5508,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2972,
    y: 35.5505,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 4.81445,
    y: 45.7339,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2972,
    y: 45.7338,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 4.81445,
    y: 55.9177,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2972,
    y: 55.9175,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 4.81445,
    y: 60.6843,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2972,
    y: 60.6844,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 4.81445,
    y: 70.8688,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2972,
    y: 70.8678,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7821,
    y: 70.8678,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 4.81445,
    y: 81.0513,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2972,
    y: 81.0515,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7821,
    y: 81.0515,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 4.81445,
    y: 85.8182,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2992,
    y: 85.8182,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 27.782,
    y: 85.8182,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 39.2659,
    y: 85.8182,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 50.7496,
    y: 85.8182,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 62.2334,
    y: 85.8182,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 4.81494,
    y: 96.0023,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2986,
    y: 96.0015,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7812,
    y: 96.0015,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 39.2651,
    y: 96.0015,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 50.7489,
    y: 96.0015,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 62.2327,
    y: 96.0015,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5072,
    y: 85.8192,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 84.9896,
    y: 85.8182,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 96.4735,
    y: 85.8182,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 107.957,
    y: 85.8182,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 119.44,
    y: 85.8182,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 130.925,
    y: 85.8182,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 73.507,
    y: 96.0023,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 84.9894,
    y: 96.0014,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 96.4733,
    y: 96.0014,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 107.957,
    y: 96.0014,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 119.44,
    y: 96.0014,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 130.925,
    y: 96.0014,
    width: 4.76673,
    height: 4.76673,
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.7437 48.2455C77.7414 48.241 77.7395 48.2365 77.737 48.2321C77.736 48.2302 77.7347 48.2286 77.7336 48.2267C77.6032 48.0031 77.4156 47.8182 77.19 47.6913L69.1802 43.1858C68.962 43.0639 68.7162 43 68.4663 43C68.2163 43 67.9705 43.0639 67.7523 43.1858L59.7423 47.6914C59.5159 47.8189 59.3277 48.0047 59.1974 48.2295C59.196 48.2319 59.1943 48.2342 59.1929 48.2366C59.1907 48.2406 59.1891 48.2447 59.1869 48.2487C59.0646 48.4661 59.0003 48.7112 59 48.9606V57.9392C59.0002 58.1976 59.069 58.4513 59.1995 58.6743C59.3299 58.8973 59.5173 59.0817 59.7424 59.2085L67.7523 63.7141C67.9541 63.8269 68.1799 63.89 68.4109 63.8981C68.4274 63.8994 68.4439 63.9009 68.4608 63.9011H68.4674C68.4903 63.9011 68.5129 63.8998 68.5353 63.8977C68.7616 63.8876 68.9825 63.8247 69.1802 63.7141L77.19 59.2085C77.4151 59.0817 77.6025 58.8973 77.733 58.6743C77.8634 58.4513 77.9322 58.1976 77.9324 57.9392V48.9606C77.9322 48.71 77.8672 48.4636 77.7437 48.2455ZM68.4662 44.4551L75.7246 48.5379L72.9374 50.1213L65.5936 46.0709L68.4662 44.4551ZM68.549 52.6145L61.219 48.5317L64.1007 46.9107L71.452 50.9652L68.549 52.6145ZM69.2055 62.0289L69.2771 53.8758L72.2001 52.2152V55.6809C72.2001 55.874 72.2768 56.0593 72.4134 56.1958C72.55 56.3324 72.7352 56.4091 72.9283 56.4091C73.1214 56.4091 73.3066 56.3324 73.4432 56.1958C73.5797 56.0593 73.6565 55.874 73.6565 55.6809V51.3878L76.4761 49.786V57.9392L69.2055 62.0289Z",
    fill: "white"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 104.877,
    y: 15.1312,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 104.877 15.1312)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 93.3923,
    y: 15.1312,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 93.3923 15.1312)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 81.9095,
    y: 15.1312,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 81.9095 15.1312)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 70.4258,
    y: 15.1312,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 70.4258 15.1312)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 58.9419,
    y: 15.1312,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 58.9419 15.1312)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 47.4581,
    y: 15.1312,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 47.4581 15.1312)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 104.877,
    y: 4.94714,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 104.877 4.94714)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 93.3929,
    y: 4.948,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 93.3929 4.948)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 81.9102,
    y: 4.948,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 81.9102 4.948)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 70.4264,
    y: 4.948,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 70.4264 4.948)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 58.9426,
    y: 4.948,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 58.9426 4.948)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 47.4589,
    y: 4.948,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 47.4589 4.948)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 36.1843,
    y: 15.1303,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 36.1843 15.1303)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7019,
    y: 15.1313,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 24.7019 15.1313)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 13.218,
    y: 15.1313,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 13.218 15.1313)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 1.73425,
    y: 15.1313,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 1.73425 15.1313)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 36.1846,
    y: 4.9472,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 36.1846 4.9472)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7021,
    y: 4.94806,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 24.7021 4.94806)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2183,
    y: 4.94806,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 13.2183 4.94806)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 1.7345,
    y: 4.94806,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 1.7345 4.94806)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 136.692,
    y: 85.8725,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 136.692 85.8725)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 125.209,
    y: 85.8727,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 125.209 85.8727)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 136.692,
    y: 75.6898,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 136.692 75.6898)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 125.209,
    y: 75.6893,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 125.209 75.6893)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 136.692,
    y: 65.5051,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 136.692 65.5051)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 125.209,
    y: 65.5056,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 125.209 65.5056)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 136.692,
    y: 55.322,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 136.692 55.322)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 125.209,
    y: 55.3223,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 125.209 55.3223)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 136.692,
    y: 45.1389,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 136.692 45.1389)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 125.209,
    y: 45.139,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 125.209 45.139)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 136.692,
    y: 34.9551,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 136.692 34.9551)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 125.209,
    y: 34.9553,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 125.209 34.9553)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 136.692,
    y: 25.1339,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 136.692 25.1339)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 125.209,
    y: 25.1338,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 125.209 25.1338)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 136.692,
    y: 14.9494,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 136.692 14.9494)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 125.209,
    y: 14.9504,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 125.209 14.9504)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 113.724,
    y: 14.9504,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 113.724 14.9504)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 136.692,
    y: 4.76697,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 136.692 4.76697)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 125.209,
    y: 4.76672,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 125.209 4.76672)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 113.724,
    y: 4.76672,
    width: 4.76673,
    height: 4.76673,
    transform: "rotate(180 113.724 4.76672)",
    fill: "#FFDC5D",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedBox);
export default __webpack_public_path__ + "static/media/dottedBox.68ddc77277a6cedd7798e3beb1550ade.svg";
export { ForwardRef as ReactComponent };